import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, SuiModalService, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { FinanceService } from '../../services';
interface IPaymentDetailModalContext {
	data: any;
	title?: string;
	isEdit?: boolean;
}
@Component({
	selector: 'app-payment-detail-modal',
	templateUrl: './edit-director-modal.component.html',
	styleUrls: [ './edit-director-modal.component.scss' ]
})
export class PaymentDetailModalComponent implements OnInit, OnDestroy {
	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;
	detailPayment;
	paymentDetail: any;
	constructor(
		private companySvc: FinanceService,
		private modalService: SuiModalService,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IPaymentDetailModalContext, void, void>
	) {
		this.paymentDetail = modal.context.data;
		this.getInvoiceDetail();
		// }
	}

	submit() {
		this.modal.approve(<any>{
			invoiceDetails: this.detailPayment,
			paymentDetail: this.paymentDetail
		});
	}

	getInvoiceDetail() {
		this.pending = true;
		this.companySvc
			.getPaymentTransactionDetail({ gatewayTransactionRefId: this.paymentDetail.gatewayTransactionRefId })
			.subscribe(
				(res) => {
					this.pending = false;
					res['gatewayResponse'] = res['gatewayResponse'] ? JSON.parse(res['gatewayResponse'])[0] : {};
					this.detailPayment = res;
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class PaymentDetailModal extends ComponentModalConfig<IPaymentDetailModalContext, void, void> {
	constructor(title: string, data: string, size: ModalSize = ModalSize.Small) {
		super(PaymentDetailModalComponent, { title, data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
